import styled from '@bd/bdui-styles/emotion';
import PhotoList from '@bd/bdui-photolist';

export default styled(PhotoList)`
  display: none;
  .PhotoList_inner {
    display: flex;
    width: 100%:
  }
  .PhotoList_list {
    flex: 3;
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
    flex-flow: row wrap;
  }
  .PhotoList_item {
    list-style: none;
    margin: 0;
    padding: 0 2.5px;
    width: 25%;
    a {
      position: relative;
      display: block;
    }
  }
  .PhotoList_imageTitle {
    display: none;
  }
  .PhotoList_image {
    position: relative;
    z-index: 0;
    width: 100%;
    padding-top: 90%;
    background-size: cover;
    background-position: center center;
    z-index: 1;
  }
  @media (min-width: 992px) {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/PhotoList.js